export default class Authors {

    constructor() {

        this.authorsListID = 'authorsList';
        this.authorsSectionID = 'authorsSection';

        this.authorsData = [];

        this.authorsLatin = [];
    }

    init() {
        if (document.getElementById(this.authorsListID) && document.getElementById(this.authorsSectionID)) {
            this.getAuthors().then(r => {

                this.generateSectionsHTML();

                this.generateSearchHTML();
            });
        }
    }

    async getAuthors() {

        const spinner = document.getElementById("spinner");

        spinner.classList.add('show');

        await fetch(apiUrl + '/authors')
            .then(response => response.json())
            .then(data => {
                this.authorsData = data.data;
                this.authorsLatin = data.dataLatin;

                let translator = new CyrLatConverter().init({
                    ignoreClasses: ['ignore'],
                });

                this.authorsLatin.map(function (item) {
                    item.value = translator.getC2L(item.value);
                    return item;
                })

                spinner.classList.remove('show');
            })
    }

    generateSearchHTML() {

        $('#authorsList').autocomplete({
            lookup: [...this.authorsData, ...this.authorsLatin],
            showNoSuggestionNotice: true,
            noSuggestionNotice: 'Nema rezultata',
            onSelect: function (suggestion) {
                window.location.href = suggestion.data;
            },
        });
    }

    getGroupedAuthors() {

        let groupedAuthors = this.authorsData.reduce((r, e) => {

            let group = e.value[0]; // get first letter of name of current element

            if (!r[group]) r[group] = {group, children: [e]} // if there is no property in accumulator with this letter create it

            else r[group].children.push(e); // if there is push current element to children array for that letter

            return r; // return accumulator
        }, {})

        // since data at this point is an object, to get array of values
        // we use Object.values method
        return Object.values(groupedAuthors)
    }

    generateSectionsHTML() {
        let groupedAuthors = this.getGroupedAuthors();

        let authorsHTML = authorGroups(groupedAuthors);

        function authorGroups(groups) {
            let authorGroupsHTML = '';
            groups.forEach(function (item, index) {
                authorGroupsHTML += `
                        <div class="authors__category">
                            <span class="authors__category-letter">
                                ${item.group}
                            </span>
                            <ul class="authors__category-list">
                                 ${authorList(item.children)}
                            </ul>
                        </div>`
            })
            return authorGroupsHTML;
        }

        function authorList(data) {
            let authorHTML = '';
            data.forEach(function (newItem, index) {
                authorHTML += `
                        <li>
                            <a href="${newItem.data}">
                                ${newItem.value}
                            </a>
                        </li>`
            })
            return authorHTML;
        }

        document.getElementById(this.authorsSectionID).innerHTML = authorsHTML;
    }

}



// WEBPACK FOOTER //
// ./static/js/components/Authors.js